export default "__VITE_ASSET__BwJuPWCt__"